import { Component, OnInit, ViewChild, Input, Output, EventEmitter } from '@angular/core';
import {
  AppSettings,
  ICustomerPaymentInfo,
  PaymentAfterSave,
  PaymentBeforeSave,
  PaymentError,
  PaymentMethodService,
} from 'pac-api';
import { Subject, BehaviorSubject, Observable } from 'rxjs';
import { map } from 'rxjs/operators';
import { ModalDirective } from 'ngx-bootstrap/modal';
import { SubSink } from 'subsink';

@Component({
  selector: 'app-checkout-payment-modal',
  templateUrl: './checkout-payment-modal.component.html',
  styleUrls: ['./checkout-payment-modal.component.scss']
})
export class CheckoutPaymentModalComponent implements OnInit {

  @ViewChild('pinModal', { static: true, read: ModalDirective })
  public pinModal: ModalDirective;

  @Input()
  public CustomerPaymentInfo: ICustomerPaymentInfo

  @Output()
  public Dismiss: EventEmitter<void> = new EventEmitter<void>();

  @Output()
  public Update: EventEmitter<ICustomerPaymentInfo> = new EventEmitter<ICustomerPaymentInfo>();

  public Action: 'Insert' | 'Update';

  public Busy$: Subject<boolean> = new BehaviorSubject(false);

  public PaymentMethods$: Observable<any[]>;

  private subsink: SubSink = new SubSink();

  constructor(
    private paymentMethodService: PaymentMethodService,
    private Settings: AppSettings
  ) { }

  public ngOnInit(): void {

    this.Action = this.CustomerPaymentInfo.cpi_key ? 'Update' : 'Insert';

    this.PaymentMethods$ = this.paymentMethodService.Get().pipe(
      map(methods => {
        if (this.CustomerPaymentInfo.cpi_key) {
          return methods;
        } else {
          return methods.filter(apm => apm.asn_code === this.Settings.pac_base_asn_code);
        }
      })
    );

  }

  public ngOnDestroy(): void {
    if (this.subsink) {
      this.subsink.unsubscribe();
    }
  }

  public ngAfterViewInit(): void {
    this.pinModal.config.ignoreBackdropClick = true;
    this.pinModal.show();
  }


  public OnBeforeSave(event: PaymentBeforeSave): void {
  }

  public OnAfterSave(event: PaymentAfterSave): void {
    this.Update.emit(event.cpi);
    this.Close();
  }

  public OnError(event: PaymentError): void {
  }


  public Close(): void {
    this.pinModal.hide();
    this.Dismiss.next();
  }

}
